import { LearningObjectAuthorization } from '@hendrx/core/common/components/pages/Player/Authorization/LearningObjectAuthorization';
import { PlayerLearningActivityPage } from '@hendrx/core/learningActivity/pages/PlayerLearningActivityPage';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/player/learning-activity/$learningActivityDraftId')({
  component: RouteComponent,
  validateSearch: z.object({
    mode: z.string().optional()
  })
});

function RouteComponent() {
  const { learningActivityDraftId } = Route.useParams();
  const { mode } = Route.useSearch();
  const isPlayerAsPreview = mode === 'preview';
  return (
    <LearningObjectAuthorization learningObjectDraftId={learningActivityDraftId} checkPlenaryRedirect>
      <PlayerLearningActivityPage
        isPlayerAsPreview={isPlayerAsPreview}
        learningActivityDraftId={learningActivityDraftId}
      />
    </LearningObjectAuthorization>
  );
}
